/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 *
 * Action types for OnlineCategories.
 *
 */

import { ReduxUtils } from '@spm/core';

const FETCH_SD_ONLINE_CATEGORIES = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `ONLINECATEGORIES/FETCH_SD_ONLINE_CATEGORIES`
);

export { FETCH_SD_ONLINE_CATEGORIES };
